import React from "react";
import { API_URL } from "./../../utils/Constants";
import { Typography } from "@mui/material";
import { DownloadTempLogo } from "../../assets/icons";
import { colors } from "../../config/colors";
import {
  ADMIN_TYPE,
  STUDENT_UPLOAD_TILES,
  API_AUTH_TOKEN,
  API_CONTEXT_TYPE,
  API_METHOD_POST,
  STUDENT_DATA_CONSTANTS,
} from "../../config/constants";
import { TEXT_ALIGN_LEFT } from "../../config/styles";

const DownloadTemplate = () => {
  const handleDownloadTemplate = (type = STUDENT_UPLOAD_TILES[0].action) => {
    let authCode = localStorage.getItem("bearer");
    let roleData = localStorage.getItem("role");
    let merchantIdGlobal = "";
    if (roleData == ADMIN_TYPE.SUPER_ADMIN) {
      merchantIdGlobal = localStorage.getItem("globalMerchantId");
    }
    if (roleData == ADMIN_TYPE.SCHOOL_ADMIN) {
      merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
    }
    const typeUrl =
      type === STUDENT_UPLOAD_TILES[0].action
        ? API_URL.DOWNLOAD_UPDATE_TEMPLATE
        : API_URL.DOWNLOAD_DELETE_TEMPLATE;
    const url = typeUrl + "?schoolId=" + merchantIdGlobal;
    fetch(url, {
      method: API_METHOD_POST,
      headers: {
        Authorization: authCode,
        "X-Auth-Token": API_AUTH_TOKEN,
        Accept: API_CONTEXT_TYPE,
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.blob();
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "StudentData.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((err) => alert(err));
  };

  return (
    <div className="my-4">
      <Typography variant="subtitle2" component="span">
        {STUDENT_DATA_CONSTANTS.DOWNLOAD_TEMPLATE_HEADER}
      </Typography>

      <div className="d-flex flex-row mt-3 gap-3">
        {STUDENT_UPLOAD_TILES.map((tile) => (
          <button
            className="upload-card"
            onClick={() => handleDownloadTemplate(tile.action)}
            key={tile.action}
          >
            <DownloadTempLogo />
            <div>
              <Typography
                variant="body1"
                className="mb-2"
                sx={{ color: colors.primary }}
              >
                {tile.title}
              </Typography>
              <Typography
                variant="h4"
                sx={{ color: colors.grayLight, textAlign: TEXT_ALIGN_LEFT }}
              >
                {tile.description}
              </Typography>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DownloadTemplate;
